import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   GET_PURCHASE_CHALLANS,
   ADD_PURCHASE_CHALLAN,
   GET_PURCHASE_CHALLAN,
   UPDATE_PURCHASE_CHALLAN,
   DELETE_PURCHASE_CHALLAN,
   GET_LAST_PURCHASE_CHALLAN_DAYBOOK,
   DELETE_MULTI_PURCHASE_CHALLAN_INVOICE,
   EMPTY_ONE_PURCHASE_CHALLAN_INVOICE,
   GET_PURCHASE_ORDER_DOCUMENT,
   GET_PURCHASE_CHALLAN_DOCUMENT,
} from '../types';

export const addPurchaseChallan = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchase-challan/add`, formData);
      if (res.data.code === 1) {
         dispatch({
            type: ADD_PURCHASE_CHALLAN,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         setTimeout(() => {
            toast.success('Purchase Challan added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err?.response?.data?.message);
         return err?.response?.data;
      }
   }
};

export const getPurchaseChallans = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-challan/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_CHALLANS,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
            },
         });
      }
   } catch (err) {
      console.error('getPurchaseChallans err', err);
   }
};

export const getPurchaseChallan = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-challan/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_CHALLAN,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
   } catch (err) {
      console.error('getPurchaseChallan err', err);
   }
};

export const updatePurchaseChallan = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/purchase-challan/update`, formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_PURCHASE_CHALLAN, payload: res.data.data });
         setTimeout(() => {
            toast.success('Purchase Challan updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
      return err.response?.data;
   }
};

export const deletePurchaseChallan = (id, outAdjustmentIds = null) => async (dispatch) => {
   try {
      if (!id) {
         toast.warn('Please select any record', 'warning');
         return false;
      }
      let res;
      if (outAdjustmentIds && outAdjustmentIds.length > 0) {
         res = await axios.post(`/purchase-challan/delete/${id}`, {
            outAdjustmentIds: outAdjustmentIds,
         });
      } else {
         res = await axios.post(`/purchase-challan/delete/${id}`);
      }

      if (res.data.code === 1) {
         dispatch({ type: DELETE_PURCHASE_CHALLAN, payload: { id } });
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }

      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
   }
};

export const deleteMultiPurchasechallanInvoice = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post("/purchase-challan/delete/multi", formData);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_MULTI_PURCHASE_CHALLAN_INVOICE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Purchase challan deleted successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const getLastPurchaseChallanDaybook = (params) => async (dispatch) => {
   try {
      // const res = await axios.get(`/purchase/last`, { params });
      const res = await axios.get(`/purchase-challan/lastDocNo`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_LAST_PURCHASE_CHALLAN_DAYBOOK, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      console.error('getLastPurchaseDaybook err', err);
   }
};

export const getOrderDocument = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-order/pending`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_ORDER_DOCUMENT,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      console.error('getIssues err', err);
   }
};

export const getChallanDocument = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/purchase-challan/pending`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PURCHASE_CHALLAN_DOCUMENT,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      console.error('getIssues err', err);
   }
};

export const checkDocNo = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/purchase-challan/checkDocNo', data);
      if (res.data.code === 1) {
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

export const emptyPurchase = () => async (dispatch) => {
   console.log('reset...');
   dispatch({ type: EMPTY_ONE_PURCHASE_CHALLAN_INVOICE, payload: null });
};
